import { AxiosResponse } from 'axios'

/**
 * Перехватчик успешного выполнения запроса
 * @param {AxiosRequestConfig} axios
 */
// flowlint-next-line unclear-type:off
export function ResponseInterceptorSuccess(axios: AxiosResponse): AxiosResponse {
  return axios
}
